module.exports = "./img/c7c668e8e979bc2045cb79b751bba972.jpg";